import { useEffect } from 'react';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';

export const useFastshiftPageAnalytics = () => {
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
	const { fireScreenEvent } = useFireAnalyticsEvents(identityAttrs);

	useEffect(() => {
		if (!identityAttrs) return;

		fireScreenEvent({
			name: sourceKey,
		});
	}, [fireScreenEvent, sourceKey, identityAttrs]);
};
